export default __webpack_public_path__ + "static/media/chatdesk-logo-dark.b5fb8831.svg";